import React from 'react';
import { cn } from '../../lib/utils';

const variants = {
  primary:
    'bg-pond text-offwhite hover:bg-moss hover:text-pond shadow-md hover:-translate-y-0.5',
  secondary:
    'border border-pond text-pond bg-transparent hover:bg-pond hover:text-offwhite',
  ghost:
    'text-pond underline underline-offset-4 decoration-moss hover:decoration-pond bg-transparent px-0 py-0 rounded-none',
  inverted:
    'bg-offwhite text-pond hover:bg-sand shadow-md hover:-translate-y-0.5',
};

const sizes = {
  sm: 'px-5 py-2.5 text-sm',
  md: 'px-7 py-3.5 text-sm',
  lg: 'px-9 py-4 text-base',
};

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className,
  as: As = 'button',
  ...props
}) {
  return (
    <As
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-full font-sans font-medium tracking-wide transition-all duration-300 disabled:opacity-50 disabled:pointer-events-none',
        variants[variant],
        variant !== 'ghost' && sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </As>
  );
}
